import React from 'react';
import './SidebarItem.css';

const SidebarItem = ({ icon: Icon, text, onClick = () => { }, additionalClassNames = '' }) => {
    return (
        <div className={`sidebar-item ${additionalClassNames}`}>
            <button onClick={onClick}>
                {Icon && <Icon />}
                <span>{text}</span>
            </button>
        </div>
    );
};

export default SidebarItem;
